// Recovery-Code-Helper. Backend-Endpoints unter /v2-api/auth/recovery.
//
// Die Klartext-Codes werden vom Backend nur EINMAL geliefert
// (Generate-Response). Caller muss sie in der UI direkt darstellen +
// dem User einen Druck/Download-Button anbieten; ein zweites Mal
// holen geht nicht.

import { getJSON, postJSON } from "./api";

export interface RecoveryStatus {
  active: number;
  generation: number;
  has_codes: boolean;
}

export interface RecoveryGenerateResponse {
  codes: string[];
  generation: number;
}

export async function getRecoveryStatus(): Promise<RecoveryStatus> {
  return await getJSON<RecoveryStatus>("/v2-api/auth/recovery/status");
}

export async function generateRecoveryCodes(): Promise<RecoveryGenerateResponse> {
  return await postJSON<RecoveryGenerateResponse>(
    "/v2-api/auth/recovery/generate",
  );
}

export async function useRecoveryCode(
  code: string,
): Promise<{ ok: true; remaining: number }> {
  // Use ist ein anonymer Endpoint -- postJSON funktioniert weil das
  // Backend ihn aus der CSRF-Pflicht ausnimmt. credentials:include
  // setzt die Cookies wenn der Server sie ausstellt.
  return await postJSON<{ ok: true; remaining: number }>(
    "/v2-api/auth/recovery/use",
    { code },
  );
}
